import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export const useStyles = makeStyles({
  root: {
    height: '100%'
  },
  content: {
    position: 'relative',
    margin: '0 auto',
    paddingTop: '5%',
    paddingBottom: '5%',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      padding: 0,
      flexDirection: 'column'
    }
  }
})
